import { Button, Descriptions, List, Row, Typography } from "antd";
import Boleto from "../../../../../../Models/Financeiro/Titulo/Pagamento/Boleto";
import { useObterLinkBoleto } from "@/Services/Financeiro/Titulo/Pagamento/BoletoServices";
import { createRef } from "react";
// import { ListItemTypeProps } from "antd/es/list/Item";
interface IBoletoListItemProps extends React.ComponentProps<typeof Descriptions> {
    data:Boleto
}
export default function BoletoListItem({
    data,
    ...props
}:IBoletoListItemProps) {
    const refCopy = createRef<HTMLSpanElement>();

    const {
        mutateAsync : gerarLinkAsync
    } = useObterLinkBoleto({
        onSuccess(data, variables, context) {
        }
    });

    return <Descriptions {...props}>
        <Descriptions.Item label="Forma">{data.tipo?.nome}</Descriptions.Item>
        <Descriptions.Item label="Conta">{data.conta?.nome ?? data.codConta}</Descriptions.Item>
        <Descriptions.Item label="Documento">{data.documento}</Descriptions.Item>
        <Descriptions.Item label="Nosso número">{data.nossoNumero}</Descriptions.Item>
        <Descriptions.Item label="Número banco">{data.nossoNumeroBanco}</Descriptions.Item>
        <Descriptions.Item label="Remessa">{data.numeroArquvoRemessa}</Descriptions.Item>
        {data.identificadorProvedorCancelamento && <Descriptions.Item label="Identificador Banco (Cancelamento)">{data.identificadorProvedorCancelamento}</Descriptions.Item>}
        <Descriptions.Item label="Link pagamento">
                <Typography.Text 
                    ref={refCopy} 
                    copyable={{
                        tooltips : false,          
                        text : () => gerarLinkAsync({ ...data }).then(resp => resp).catch((err) => err)
                    }}
                >
                    <Button size="small" type="link" onClick={() => {
                        const janela = window.open();
                        gerarLinkAsync({ ...data }).then(resp => {
                            if (janela)
                                janela.location.href = resp;
                        }).catch((err) => err);
                    }}>Copiar link boleto</Button>
                </Typography.Text>
        </Descriptions.Item>
    </Descriptions>;
}